// 中文翻译
export const zh = {
  title: 'HandinCap',
  subtitle: '让每一杆都算数',
  create: '创建新局',
  courseTitle: '球场设置',
  autoMode: '自动搜索',
  manualMode: '手动输入',
  searchPlaceholder: '搜索球场名称...',
  selectCourse: '选择球场',
  gameType: '比赛类型',
  setPar: '设置各洞PAR值',
  confirmCourse: '确认设置',
  playerTitle: '玩家设置',
  players: '玩家',
  player1: '玩家1',
  player2: '玩家2',
  player3: '玩家3',
  player4: '玩家4',
  player5: '玩家5',
  player6: '玩家6',
  player7: '玩家7',
  player8: '玩家8',
  enterName: '输入姓名',
  gameMode: '游戏模式',
  matchPlay: 'Match Play',
  win123: 'Win123',
  skins: 'Skins',
  baccarat: '百家乐',
  stake: '底注',
  prizePool: '奖金池',
  penaltyPot: '罚金池',
  optional: '可选',
  enterStake: '输入金额（可选）',
  handicap: '差点',
  handicapSettings: '差点设置',
  off: '关',
  on: '开',
  back: '返回',
  start: '开始比赛',
  hole: '洞',
  par: 'PAR',
  nextHole: '确认成绩',
  currentMoney: '实时战况',
  poolBalance: '奖池余额',
  holeTied: '本洞平局',
  poolGrows: '下洞奖池',
  skinsWinner: '{player}赢得Skins！',
  holeSettlement: '该洞结算',
  netScore: '净杆',
  rank: '第{n}名',
  winner: '胜利',
  resume: '继续比赛',
  finishRound: '确认并结束',
  kaki: '球友',
  kakiDeleteConfirm: '确定删除这组球友吗?',
  confirmHoleScore: '确认第{hole}洞成绩',
  holeScoresSummary: '各玩家成绩：',
  cancel: '取消',
  yes: '确定',
  confirm: '确认',
  switchLang: '语言',
  noStake: '请输入底注金额',
  atLeast2: '请至少输入2名玩家',
  gameOver: '比赛结束！',
  backToHome: '回到首页',
  out: '前九',
  in: '后九',
  total: '计',
  totalScore: '总成绩',
  standardPar: '标准杆',
  finalSettlement: '最终结算',
  noScoreData: '还没有开始记分',
  f9: '前9洞',
  b9: '后9洞',
  f18: '前18洞',
  b18: '后18洞',
  f9Desc: '1-9洞',
  b9Desc: '10-18洞',
  f18Desc: '1-18洞标准',
  b18Desc: '10-18,1-9洞',
  duplicateNames: '玩家名不可重复',
  screenshotHint: '建议您先截图保存成绩记录',
  totalLoss: '累计',
  totalPar: 'PAR',
  noCourses: '未找到球场',
  trySearch: '请尝试其他关键词',
  front9: '前九',
  back9: '后九',
  eagle: '老鹰',
  birdie: '小鸟',
  parLabel: '标准杆',
  bogey: '柏忌',
  doubleplus: '双柏忌+',
  selectHoleToEdit: '选择要修改的洞',
  holeJumpTitle: '跳到第几洞',
  holeJumpReturnToast: '还有 {n} 个洞没打，回到第 {hole} 洞',
  editHole: '修改',
  save: '保存',
  scoreUpdated: '成绩已更新，金额已重算',
  // 游戏模式说明
  matchPlayDesc: '每洞最低净杆者赢，输家付底注',
  win123Desc: '按名次罚款入池，可喊UP赌大',
  skinsDesc: '每洞投注，唯一低杆者通吃',
  baccaratDesc: '两两对战，UP加倍赌注',
  // 报告相关
  reportTitle: '的比赛报告',
  scoreDistribution: '成绩分布',
  puttingAnalysis: '推杆分析',
  totalPutts: '总推杆',
  avgPerHole: '平均/洞',
  onePutt: '一推进洞',
  threePutts: '三推及以上',
  holes: '洞',
  penaltyStats: '罚杆统计',
  waterHazard: '水障碍',
  stats: '统计',
  attempts: '尝试',
  times: '次',
  holeByHole: '逐洞成绩',
  viewFullDetail: '查看完整明细',
  fullDetail: '完整明细',
  strokes: '杆',
  putt: '推',
  water: '水障',
  clickNameToView: '点击名字查看详情',
  // 推杆确认
  confirmPutts: '确认推杆数',
  zeroPuttsWarning: '以下玩家推杆数为 0：',
  puttsScore: '成绩',
  puttsStrokes: '杆',
  puttsPutts: '推杆',
  puttsTip: '提示：除非是切杆进洞(chip-in)，否则推杆数通常不为 0',
  puttsGoBack: '返回修改',
  puttsConfirm: '确认无误',
  // 多人同步
  mpMultiplayer: '多人同步',
  mpSync: '多人同步',
  mpCodePlaceholder: '房间码',
  mpEnter6Digit: '请输入4位房间码',
  mpJoin: '加入',
  mpPointQr: '对准QR码扫描',
  mpQrLoadFail: 'QR库加载失败',
  mpLinkCopied: '链接已复制！',
  mpCopyLink: '复制链接',
  mpShareLink: '分享',
  startSolo: '单人开始',
  mpJumbo: '多人',
  mpCreateRoom: '创建房间',
  mpWaitingPartner: '等待同伴加入',
  mpWaitingStart: '等待开始',
  mpRoomCode: '房间码',
  mpCopied: '已复制',
  mpCopyCode: '复制房间码',
  mpScanToJoin: '扫码加入',
  mpGameInfo: '比赛信息',
  mpCourse: '球场',
  mpMode: '模式',
  mpStake: '底注',
  mpRoom: '房间',
  mpPlayerAssignment: '球员分配',
  mpMine: '我的',
  mpPartner: '对方',
  mpUnclaimed: '未认领',
  mpConnected: '已连接',
  mpError: '连接错误',
  mpConnecting: '连接中...',
  mpStartGame: '开始比赛',
  mpWaitingCreator: '等待创建者开始比赛...',
  mpClaimTitle: '选择你的球员',
  mpClaimDesc: '选择你要负责输入成绩的球员',
  mpSelectOne: '请至少选择一位球员',
  mpConfirmClaim: '确认认领',
  mpConfirmSubmit: '确认提交',
  mpWaiting: '等待对方...',
  mpConfirmFinish: '确认 & 完成',
  mpConfirmNext: '确认 & 下一洞',
  mpAdvancedStats: '高级统计模式',
  mpHolesLabel: '洞',
  // ===== Additional UI keys =====
  hcpLabel: '差点',
  hideInfo: '收起说明',
  learnMore: '了解更多',
  close: '关闭',
  clearRecent: '清除',
  recentCourses: '最近球场',
  endGame: '终止',
  shareRoundReport: '分享回合报告',
  allDataCleared: '所有比赛数据将被清除',
  endGameConfirm: '确定要终止比赛吗？\n未完成的洞将不计入成绩',
  holeLabel: '{n}洞',
  holeLabelShort: '{n}洞',
  cameraAccessDenied: '无法访问相机',
  generateLinkFailed: '生成链接失败',
  copyFailed: '复制失败',
  retracted: '已撤回，可修改分数',
  matchPlayBubble: '每洞净杆最低者赢。平手就没有输赢。',
  win123Bubble: '按净杆排名。排名越低罚越重。UP可以赢更多，也可能输更多。',
  skinsBubble: '每洞每人投注。只有单独最低杆才赢走全部。平手就累积到下一洞。',
  baccaratBubble: '4人两两对战，共6组对决。叫UP可以加注。',
  mpSyncBubble: '你记你的球员，朋友记他的，分数自动同步。不用再传来传去。',
  hcpBubble: '差点(0-36)：让不同水平的球员公平竞争。系统根据球场难度自动分配让杆到各洞。',
  undoEdit: '撤回修改',
  waitingProceed: '等待 {badge} 进入下一洞...',
  voiceWithHcp: '{player}，{on}上{putt}推，让杆{handicap}。',
  voiceNoHcp: '{player}，{on}上{putt}推。',
  voiceHoleIntro: '第{hole}洞，标准杆{par}，难度指数{index}。',
  voiceHoleIntroNoIdx: '第{hole}洞，标准杆{par}。',
  voiceHcpOnHole: '{player}让{strokes}杆',
  ttsLang: 'zh-CN',
  // Edit Log 修改记录
  editLogTitle: '修改记录',
  editLogHoleTitle: '第{n}洞 修改记录',
  editLogEmpty: '没有修改记录',
  editLogCount: '{n} 条修改',
  editLogAllRecorded: '所有编辑操作均已记录',
  editLogScore: '杆数',
  editLogPutts: '推杆',
  editLogUp: 'UP',
  editNotifyTitle: '第{n}洞 成绩被修改',
  editNotifyBy: '由 {who} 编辑',
  editNotifyDetail: '点击查看详情',
  editLogTapHint: '点击洞号上查看该洞修改记录',
  editLogClose: '关闭',
  // Viewer Mode 观战模式
  mpRoleTitle: '加入房间',
  mpRoleDesc: '选择加入方式',
  mpPlayerRole: '球员',
  mpPlayerRoleDesc: '认领球员并输入杆数',
  mpPlayerTagInput: '输入杆数',
  mpPlayerTagClaim: '认领球员',
  mpViewerRole: '观战',
  mpViewerRoleDesc: '实时观看比赛，只读',
  mpViewerTagLive: '实时比分',
  mpViewerTagNoInput: '无法输入',
  mpViewerBanner: '仅观战 — 无法输入杆数',
  mpViewerReminder: '你正在观看此比赛',
  mpViewerReminderDesc: '成绩实时更新，你无法输入或修改杆数。',
  exit: '退出',
  // Scorecard Section 记分卡
  scorecardHorizontal: '横向',
  scorecardVertical: '纵向',
  shareBtn: '分享',
  penalties: '罚杆',
  // Feedback 反馈
  feedbackBtn: '反馈意见',
  feedbackTitle: '意见反馈',
  feedbackSubtitle: '帮助我们改进 HandinCap',
  feedbackRateLabel: '整体体验评分',
  feedbackCatLabel: '您希望改进的方面（可多选）',
  feedbackCatNewModes: '增加比赛类型',
  feedbackCatUI: '界面优化',
  feedbackCatSpeed: '速度/性能',
  feedbackCatCourse: '球场数据',
  feedbackCatScoring: '计分功能',
  feedbackCatMultiplayer: '多人模式',
  feedbackCatBug: 'Bug 报告',
  feedbackCatOther: '其他建议',
  feedbackCommentPlaceholder: '请告诉我们您的想法...\n例如：希望增加 Nassau 玩法',
  feedbackSubmit: '提交反馈',
  feedbackSubmitting: '提交中...',
  feedbackThanks: '感谢您的反馈！',
  feedbackThanksDetail: '我们会认真阅读每一条建议',
  feedbackSkip: '以后再说',
  feedbackStar1: '很差',
  feedbackStar2: '一般',
  feedbackStar3: '还行',
  feedbackStar4: '很好',
  feedbackStar5: '太棒了！',
  // 分享页面
  shareInvalidLink: '无效链接',
  shareInvalidDesc: '此分享链接无效或已过期。',
  shareGoTo: '前往 HandinCap',
  poweredBy: '由',
  onLabel: '上果岭',
  avg: '平均',
  totalLabel: '总计',
  // 多人模式补充
  mpConnectionStatus: '连接状态',
  mpPlayersJoined: '已加入球员',
  mpViewersJoined: '已加入观众',
  mpNoPlayersYet: '还没有球员加入。你仍可以开始——你将为所有球员记分。',
  mpProcessing: '处理中...',
  mpClaimed: '已认领',
  mpNoPlayers: '暂无可用球员',
  ob: 'OB',
  allConfirmed: '全部已确认',
  liveSyncing: '实时同步中',
  justNow: '刚刚',
  minsAgo: '{n}分钟前',
  hrsAgo: '{n}小时前',
  roomNotFound: '房间未找到',
  // Round Report
  rrTitle: '回合报告',
  rrGolfCourse: '高尔夫球场',
  rrTotalScorePar: '总成绩 (标准杆: {n})',
  rrShareImage: '分享图片',
  rrShareLink: '分享链接',
  rrImageDownloaded: '图片已下载',
  rrImageFailed: '生成图片失败',
  rrScreenshotFailed: '截图失败，请手动截屏',
  rrOpenApp: '打开 HandinCap',
  loading: '加载中...',
};

export default zh;
